import React, { useEffect } from 'react';

interface Props {
  accountToken: string;
  createdAt: number;
  email: string;
  firstSurvey: number;
  productName: string;
  properties: {
    exam: string;
  };
  registeredPercent: number;
  resurveyThrottle: number;
}

export default (props: Props) => {
  useEffect(() => {
    let setupScript = document.createElement('script');
    setupScript.type = 'text/javascript';
    setupScript.id = 'wootric-settings';
    setupScript.async = true;
    setupScript.innerHTML = `
      window.wootric_first_survey = ${props.firstSurvey};
      ${props.resurveyThrottle ? `window.wootric_resurvey_throttle = ${props.resurveyThrottle};` : ''}
      ${props.registeredPercent ? `window.wootric_registered_percent = ${props.registeredPercent};` : ''}

      window.wootricSettings = {
        account_token: '${props.accountToken}',
        created_at: ${props.createdAt},
        email: '${props.email}',
        product_name: '${props.productName}',
        properties: {
          exam: '${props.properties.exam}'
        }
      };
    `;
    if (document.getElementById('wootric-settings') == null) {
      document.body.appendChild(setupScript);
    }

    // Beacon
    let beacon = document.createElement('script');
    beacon.type = 'text/javascript';
    beacon.id = 'wootric-beacon';
    beacon.async = true;

    beacon.src = 'https://cdn.wootric.com/wootric-sdk.js';
    beacon.onload = function() {
      (window as any).wootric('run');
    };
    if (document.getElementById('wootric-beacon') == null) {
      document.body.appendChild(beacon)
    };
  }, []);

 return null;
};
